import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {PlanService} from '../../../services/plan.service';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import {Action, Store} from '@ngrx/store';
import * as featureActions from '../../index';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {ConfirmKeyParams, PlanList, PlanListAddParams} from '../plan-list.model';
import {updateInfoType} from '../../../shareModel';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {Update} from '@ngrx/entity';
import {GetReadPlanList} from '../../index';
import {GetReadPlanListFails} from '../../index';



@Injectable()
export class PlanListEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private planService = inject(PlanService);

  constructor() {}

  AddPlanKey$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.PlanListActionTypes.GetAddPlanList),
    map((action: featureActions.GetAddPlanList) => action.payload.planList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([actionPayload, user]) => {
      const payload = { ...(actionPayload ?? {}) };
      const params = {...payload, otp: user.otp};
      return this.planService.AddPlanKey(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            const result = { ...res, type: updateInfoType.AddPlanList };
            const item: PlanList = result.msg['body'];
            const data: PlanList = {
              Id: item.Id,
              PlanName: item.PlanName,
              Level: item.Level,
              Package: item.Package,
              Platform: 2, // Apple(0), Android(1), PlanKey(2)
              Status: 0,
              // acode: user.acode, // Not confirm yet.
              CreateId: user.acode,
              CreateTime: item.CreateTime,
              IsConfirmed: false,
              Type: 1, // Billing Plan(0) & PlanKey(1),
              EmailInfo: payload.EmailInfo,
              PlanMgtId: payload.PlanMgtId,
              RegionId: payload.RegionId,
              IsFree: payload.IsFree,
              Period: payload.Period,
            };
            return [new featureActions.AddPlanList({planList: data}), new featureActions.UpdateInfoSuccessAction(result)];
          }
          throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddPlanList
          };
          return [new featureActions.UpdateInfoFailAction(res), new featureActions.GetReadPlanListFails()];
        })
      );
    })
  ));
  UpdatePlanKey$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.PlanListActionTypes.GetUpdatePlanList),
    map((action: featureActions.GetUpdatePlanList) => action.payload.planList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser), this.store$.select(fromStore.getPlanKeyEntities)),
    switchMap(([actionPayload, user, planKeys]) => {
      const payload = { ...(actionPayload ?? {}) };
      const params = {...payload, otp: user.otp};
      return this.planService.UpdatePlanKey(params).pipe(
        switchMap((res: any) => {
          const result = { ...res, type: updateInfoType.EditPlanList };
          if (result.result) {
            const item: PlanList = result.msg['body'];
            const change = {
              PlanName: item.PlanName,
              Level: item.Level,
              Package: item.Package,
              PlanMgtId: params.PlanMgtId,
              EmailInfo: params.EmailInfo,
              RegionId: (params.RegionId) ? params.RegionId : null,
              IsFree: params.IsFree,
              Period: params.Period,
            };
            const update: Update<PlanList> = {
              id: item.Id.toString(),
              changes: change
            };
            return [new featureActions.UpdatePlanList({planList: update}), new featureActions.UpdateInfoSuccessAction(result)];
          }
          throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditPlanList,
          };
          return [new featureActions.UpdateInfoFailAction(res), new featureActions.GetReadPlanListFails()];
        })
      );
    })
  ));
  GetDeletePlanList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.PlanListActionTypes.GetDeletePlanList),
    map((action: featureActions.GetDeletePlanList) => action.payload.id),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        Id: payload
      };
      return this.planService.DeletePlanKey(params).pipe(
        switchMap((res: any) => {
          const result = { ...res, type: updateInfoType.DeletePlanList };
          if (result.result) {
            const item = result.msg['body'];
            return [new featureActions.DeletePlanList({id: item.Id.toString()}), new featureActions.UpdateInfoSuccessAction(result)];
          }
          throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError((error) => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeletePlanList,
          };
          return [new featureActions.UpdateInfoFailAction(res), new featureActions.GetReadPlanListFails()];
        })
      );
    })
  ));
  ConfirmPlanKey$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.PlanListActionTypes.ConfirmPlanKey),
    map((action: featureActions.ConfirmPlanKey) => action.payload.id),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params: ConfirmKeyParams = {
        otp: user.otp,
        Id: payload
      };
      return this.planService.ConfirmPlanKey(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            const result = { ...res, type: updateInfoType.ConfirmPlanKey };
            const item = result.msg['body'];
            const change = {
              KeyNumber: item.Key,
              IsConfirmed: true
            };
            const update: Update<PlanList> = {
              id: item.Id.toString(),
              changes: change
            };
            return [new featureActions.UpdatePlanList({planList: update}), new featureActions.UpdateInfoSuccessAction(result)];
          }
          throw new Error('update fails');
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ConfirmPlanKey,
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
  SendPlanKey$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.PlanListActionTypes.SendPlanKeyMail),
    map((action: featureActions.SendPlanKeyMail) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        Id: payload.id
      };
      return this.planService.SendPlanKey(params).pipe(
        map((res: any) => {
          if (res.result) {
            const result = { ...res, type: updateInfoType.SendPlanKeyMail };
            return new featureActions.UpdateInfoSuccessAction(result);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.SendPlanKeyMail,
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
  ReadPlanInfoList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.PlanListActionTypes.GetReadPlanList),
    map((action: featureActions.GetReadPlanList) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([actionPayload, user]) => {
      const payload = { ...(actionPayload ?? {}) };
      const params = {...payload};
      params.otp = user.otp;
      return this.planService.ReadPlanInfoList(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body && Array.isArray(res.msg.body)) {
            if (payload && payload.syncAccountsInfo) {
              return [new featureActions.UpsertPlanLists({planLists: res.msg.body}),
                new featureActions.GetAccounts()
              ];
            } else {
              return [new featureActions.UpsertPlanLists({planLists: res.msg.body})];
            }
          }
          throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetReadPlanListFails);
        })
      );
    })
  ));

}
